import React from 'react';
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {makeStyles, createStyles} from "@material-ui/core/styles";

import GlbReceitaCard from "./GlbReceitaCard";

const useStyles = makeStyles((theme) =>
    createStyles({
        accordion: {
            marginBottom: theme.spacing(1),
        },
        summaryText: {
            fontSize: '0.9rem',
            fontWeight: 500,
        },
        countBadge: {
            fontSize: '0.8rem',
            color: '#666',
            marginLeft: theme.spacing(1),
        },
        detailsContainer: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
        },
    })
);

const GlbReceitaGroupRow = ({ groupKey, receitas, modelos, medidas, bandas, onToggleAtivo }) => {
    const classes = useStyles();

    // Parse groupKey: modeloId_medidaId_bandaId_larguraBanda_vidaPneuRaspagem
    const parts = groupKey.split('_');
    const modeloId = parts[0] ? Number(parts[0]) : null;
    const medidaId = parts[1] ? Number(parts[1]) : null;
    const bandaId = parts[2] ? Number(parts[2]) : null;
    const larguraBanda = parts[3] || '-';
    const vidaPneu = parts[4] || '-';

    const modelo = modeloId && modelos ? modelos.find(m => m.id === modeloId) : null;
    const modeloNome = modelo ? modelo.descricao : (modeloId || '-');
    const fabricanteNome = modelo && modelo.glbFabricante ? modelo.glbFabricante.descricao : '';
    const medidaNome = medidaId && medidas
        ? (medidas.find(m => m.id === medidaId) || {}).descricao || medidaId
        : '-';
    const bandaNome = bandaId && bandas
        ? (bandas.find(b => b.id === bandaId) || {}).descricao || bandaId
        : '-';

    const modeloLabel = fabricanteNome ? `${fabricanteNome} ${modeloNome}` : modeloNome;
    const summaryLabel = `${modeloLabel} | ${medidaNome} | ${bandaNome} | LB: ${larguraBanda} | Vida: ${vidaPneu}`;

    return (
        <Accordion className={classes.accordion} TransitionProps={{ unmountOnExit: true }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography className={classes.summaryText}>
                    {summaryLabel}
                </Typography>
                <Typography className={classes.countBadge}>
                    ({receitas.length} receita{receitas.length !== 1 ? 's' : ''})
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <div className={classes.detailsContainer}>
                    {receitas.map(receita => (
                        <GlbReceitaCard
                            key={receita.id}
                            receita={receita}
                            onToggleAtivo={onToggleAtivo}
                        />
                    ))}
                </div>
            </AccordionDetails>
        </Accordion>
    );
};

export default GlbReceitaGroupRow;
